module.exports = __webpack_public_path__ + "img/icon_line_cancel.d2212432.png";